import api from '../services/api';
import { getFileNameFromContentDisposition } from './contentDisposition';

export interface FacturaVentaPdfResult {
  url: string;
  fileName: string | null;
}

export async function fetchFacturaVentaPdf(nroFormulario: number): Promise<FacturaVentaPdfResult> {
  const response = await api.get(`/api/FacturasVenta/${nroFormulario}/pdf`, {
    responseType: 'blob',
  });
  const cd = (response.headers as { 'content-disposition'?: string })?.['content-disposition'];
  const fileName = getFileNameFromContentDisposition(cd) ?? null;
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  return { url, fileName };
}
